module.exports = __webpack_public_path__ + "img/pr-7.6b3e9921.png";